import React, { useState } from 'react';
import { useAuth } from './Main/Components/Context/authContext';
import Carousel from './Main/Components/Carousel/Carousel';
const Home = () => {
  const { user, logout } = useAuth();

  const getEmailPrefix = (email) => {
    const atIndex = email.indexOf('@');
    if (atIndex !== -1) {
      return email.substring(0, atIndex);
    } else {
      return email; // En caso de que el formato del correo sea incorrecto o no tenga '@'
    }
  };

  const userCurrently = getEmailPrefix(user?.email || "BeachTennista");

  // Función para capitalizar la primera letra
  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const userFirstLetterCapitalized = capitalizeFirstLetter(userCurrently);

  return (
    <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
          <h1>Hola {userFirstLetterCapitalized}</h1>
         <Carousel />
    </div>
  );
}

export default Home;
